export const variantMapping = {
  'body-24-bold': {
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.4px',
    fontWeight: 700,
  },
  'body-24-semibold': {
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.4px',
    fontWeight: 600,
  },
  'body-14-medium': {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
    width: 'max-content',
  },
  'body-12-regular': {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '-0.4px',
  },
  'body-12-medium': {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '-0.4px',
  },
  'body-14-regular': {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-14-bold': {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-14-semibold': {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },
  'body-16-medium': {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
  },
  'body-16-semibold': {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
  },
  'body-16-regular': {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
    verticalAlign: 'middle',
  },
  'body-16-bold': {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  'body-20-medium': {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.4px',
  },
  'body-20-bold': {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.4px',
  },
  'body-20-semibold': {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
    letterSpacing: '-0.4px',
  },
  'body-40-large': {
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '46px',
    letterSpacing: '-0.4px',
    textAlign: 'center',
  },
  'heading-38-bold': {
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
    letterSpacing: '-0.4px',
    verticalAlign: 'middle',
  },
  'heading-40-regular': {
    fontWeight: 400,
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '-0.4px',
    verticalAlign: 'middle',
  },
  'heading-48-bold': {
    fontWeight: 700,
    fontSize: '48px',
    lineHeight: '56px',
    letterSpacing: '-0.4px',
    verticalAlign: 'middle',
  },
  'heading-32-bold': {
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
    letterSpacing: '-0.4px',
    verticalAlign: 'middle',
  },
};
